export const getProfileImage = (profile: { profilePick: string }) => {
  return profile && profile.profilePick && profile.profilePick.length
    ? profile.profilePick
    : require('@/assets/profile/manyrobot-profile.svg')
}